import Modal from "react-bootstrap/Modal";
import MaterialIcon from "common/MaterialIcon/MaterialIcon";

const DynamicPopup = ({
  wrapperClassNames = "",
  showModal,
  setShowModal,
  showHeader,
  showFooter,
  children,
  body,
}) => {
  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      className={`success-popup ${wrapperClassNames}`}
      backdrop="static"
      keyboard={false}
    >
      {showHeader && (
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">Header</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body className="text-center pt-5">
        <MaterialIcon iconName="check_circle" iconClassName="display-4" />
        <div className="title">Success</div>
        <div className="body">
          {body}
          <br />
        </div>
        {children}
      </Modal.Body>
      {showFooter && <Modal.Footer>Footer</Modal.Footer>}
    </Modal>
  );
};

export default DynamicPopup;
